import { Box, Button, Grid, Grid2, IconButton, MenuItem, Paper, Select, Snackbar, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TableSortLabel, TablePagination, TextField, Typography } from "@mui/material";
import TokenError from '../tokenError';
import { useEffect, useState } from "react";
import {makeGetRequestToUrl} from '../commonFunc.jsx';
import {makePostRequestToUrl} from '../commonFunc.jsx';
import config from '../../config/config.js';
import prevIcon from '../../assets/icons/left-arrow.svg';
import nextIcon from '../../assets/icons/right-arrow.svg';
import { useNavigate } from "react-router-dom";
import { Label } from "flowbite-react";
import dayjs, { utc } from "dayjs";
import CloseIcon from '@mui/icons-material/Close';
import { DatePicker, DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import timezone from 'dayjs/plugin/timezone';
import customParseFormat from "dayjs/plugin/customParseFormat";

dayjs.extend(customParseFormat);
dayjs.extend(utc);

const Inspection = () => {
    const serverUrl = config.serverUrl;
    const navigate = useNavigate();
    const cities = JSON.parse(localStorage.getItem('cities'));

    const [cityFilter, setCityFilter] = useState(cities[0].city_id);
    const [rows, setRows] = useState([]);
    const [order, setOrder] = useState('desc');
    const [orderBy, setOrderBy] = useState('inspection_id');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    
    const [tokenExpired, setTokenExpired] = useState(false);
    const [open, setOpen] = useState(false);
    const [editMode, setEditMode] = useState(false);
    const operationsUrl = config.operationsUrl;
    const [message, setMessage] = useState('');
    const [snackbar, showSnackbar] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [endDate, setEndDate] = useState(dayjs());
    const [startDate, setStartDate] = useState(dayjs());
    const [plateNumber, setPlateNumber] = useState('');
    const [inspectionCategory, setInspectionCategory] = useState('');
    const [inspectionItem, setInspectionItem] = useState('');
    const [inspectedBy, setInspectedBy] = useState('');
    const [inspectionStatus, setInspectionStatus] = useState('');
    const [inspectionId, setInspectionId] = useState('');
    const [searchItemText, setSearchItemText] = useState('');
    const [chassisData, setChassisData] = useState([]);
    const [inspectionCategoryFilter, setInspectionCategoryFilter] = useState("");
    
    // Single validation state object for all form fields
    const [formErrors, setFormErrors] = useState({
        plateNumber: false,
        startDate: false,
        endDate: false,
        inspectionCategory: false,
        inspectionItem: false,
        inspectedBy: false,
        inspectionStatus: false
    });
    // const [status, setStatus] = useState('1');
    
    // Define inspection items with their selection state
    const [inspectionItems, setInspectionItems] = useState([
        { id: 'seatBelts', name: 'Seat Belts', selected: false },
        { id: 'horn', name: 'Horn', selected: false },
        { id: 'heaterDefroster', name: 'Heater/ Defroster', selected: false },
        { id: 'wipersWasher', name: 'Wipers & Washer Fluid', selected: false },
        { id: 'windshieldMirror', name: 'Windshield & Mirror', selected: false },
        { id: 'fireExtinguisher', name: 'Fire Extinguisher', selected: false }
    ]);
    
    // Update inspectionItem state when checkboxes change
    const handleItemChange = (id) => {
        const updatedItems = inspectionItems.map(item => 
            item.id === id ? { ...item, selected: !item.selected } : item
        );
        setInspectionItems(updatedItems);
        
        // Create comma-separated string of selected items
        const selectedItems = updatedItems
            .filter(item => item.selected)
            .map(item => item.name)
            .join(', ');
        
        setInspectionItem(selectedItems);
    };
    
    // Filter items based on search text
    const filteredItems = inspectionItems.filter(item => 
        item.name.toLowerCase().includes(searchItemText.toLowerCase())
    );

    const handleRequestSort = (property) => {
        const isAscending = orderBy === property && order === 'asc';
        setOrder(isAscending ? 'desc' : 'asc');
        setOrderBy(property);
        const sortedRows = [...rows].sort((a, b) => {
            if (a[property] < b[property]) return isAscending ? -1 : 1;
            if (a[property] > b[property]) return isAscending ? 1 : -1;
            return 0;
        });
        setRows(sortedRows);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleCityChange = (e) =>{
        const city =  cities.find((cityObj) => cityObj.city_id === e)
        setCityFilter(e);
    }

    const fetchInspectionData = async() => {
        try {
            const token = localStorage.getItem('token');
            const url = serverUrl + '/transport/fetch_inspection_details';
            const timestamp = new Date().getTime();
            const body = {
                token: token,
                city_id: cityFilter,
                timestamp: timestamp
            };
            const response =  await makeGetRequestToUrl(url, body);
            if (response.flag === 200) {
                console.log('response.data', response.data);
                // Apply default descending sort on inspection_id
                const sortedData = [...response.data].sort((a, b) => {
                    if (a[orderBy] > b[orderBy]) return order === 'asc' ? 1 : -1;
                    if (a[orderBy] < b[orderBy]) return order === 'asc' ? -1 : 1;
                    return 0;
                });
                
                // Filter the data based on the selected inspection category
                if (inspectionCategoryFilter && inspectionCategoryFilter !== '') {
                    const filteredData = sortedData.filter(item => 
                        item.category === inspectionCategoryFilter
                    );
                    setRows(filteredData);
                } else {
                    setRows(sortedData);
                }
            } else {
                setErrorMessage('Failed to fetch client data');
                showSnackbar(true);
                setMessage(response.message);
            }
        } catch (error) {
            console.error('Error fetching client data:', error);
        }
    }

    // Fetch chassis data to get license plate numbers
    const fetchChassisData = async() => {
        try {
            const token = localStorage.getItem('token');
            const url = serverUrl + '/transport/fetch_chassis_details';
            const timestamp = new Date().getTime();
            const body = {
                token: token,
                city_id: cityFilter,
                timestamp: timestamp
            };
            const response = await makeGetRequestToUrl(url, body);
            if(response.flag==200){
                setChassisData(response.data);
            }
            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
            }
        }
        catch (error) {
            console.log('Error fetching chassis data:', error);
        }
    }

    useEffect(()=>{
        fetchInspectionData();
        fetchChassisData();
    }, [cityFilter]);
    
    // Fetch inspection data when the category filter changes
    useEffect(() => {
        fetchInspectionData();
    }, [inspectionCategoryFilter]);

    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return; 
        }
        showSnackbar(false); 
    };

    const handleCloseAddInspection = () => {
        setOpen(false);

    }

    const handleOpenAddInspection = () => {
        setOpen(true);
        setEditMode(false);
        setInspectedBy('');
        // setStatus('1');
        setInspectionId('');
        setEndDate(dayjs());
        setStartDate(dayjs());
        setInspectionCategory('');
        setInspectionItem('');
        setInspectionStatus('');
        setPlateNumber('');
        setInspectionItems([
            { id: 'seatBelts', name: 'Seat Belts', selected: false },
            { id: 'horn', name: 'Horn', selected: false },
            { id: 'heaterDefroster', name: 'Heater/ Defroster', selected: false },
            { id: 'wipersWasher', name: 'Wipers & Washer Fluid', selected: false },
            { id: 'windshieldMirror', name: 'Windshield & Mirror', selected: false },
            { id: 'fireExtinguisher', name: 'Fire Extinguisher', selected: false }
        ])
        setFormErrors({
            plateNumber: false,
            startDate: false,
            endDate: false,
            inspectionCategory: false,
            inspectionItem: false,
            inspectedBy: false,
            inspectionStatus: false
        });
    }

    const handleSubmit = async() =>{
        // Validate all required fields
        const errors = {
            plateNumber: !plateNumber,
            startDate: !startDate,
            endDate: !endDate,
            inspectionCategory: !inspectionCategory,
            inspectionItem: !inspectionItem,
            inspectedBy: !inspectedBy,
            // inspectionStatus: inspectionStatus === ''
        };
        
        // Update error state
        setFormErrors(errors);
        
        // Check if any validation errors exist
        if (Object.values(errors).some(error => error)) {
            setMessage('Please fill in all required fields');
            showSnackbar(true);
            return; // Prevent form submission
        }
        
        const token = localStorage.getItem('token');
        const payload = {
            token: token,
            city_id: cityFilter,
            license_plate_no: plateNumber,
            start_date: startDate,
            end_date: endDate,
            category: inspectionCategory,
            item: inspectionItem,
            inspection_by: inspectedBy,
            inspection_status: inspectionStatus == 1 ? 1 : 0
            
        };
        if(editMode && inspectionId!=''){
            payload.inspection_id = inspectionId;
            // payload.status = status==1 ? 1 : 0;
        }

        try {
            const url = operationsUrl + '/transport/add_update_inspections';
            const response = await makePostRequestToUrl(url,payload);
            if (response.flag === 200) {
                setMessage(response.message)
                showSnackbar(true);
                setOpen(false);
                setEditMode(false);
                fetchInspectionData();

            } else {
                setMessage(response.message)
                showSnackbar(true);
            }

        } catch (error) {
            console.error('Error', error);
            setMessage(error);
        }

    }

    const handleOpenEditChassis = (row) => {
        setInspectionId(row.inspection_id);
        setPlateNumber(row.license_plate_no);
        setStartDate(dayjs(row.start_date));
        setEndDate(dayjs(row.end_date));
        setInspectionCategory(row.category);
        setInspectionItem(row.item);
        setInspectedBy(row.inspection_by);
        setInspectionStatus(row.inspection_status);
        // setStatus(row.status);
        
        // Parse the comma-separated inspection items and update checkbox states
        const selectedItemNames = row.item ? row.item.split(', ') : [];
        
        // Reset and update inspection items based on what's in the data
        const updatedItems = [
            { id: 'seatBelts', name: 'Seat Belts', selected: selectedItemNames.includes('Seat Belts') },
            { id: 'horn', name: 'Horn', selected: selectedItemNames.includes('Horn') },
            { id: 'heaterDefroster', name: 'Heater/ Defroster', selected: selectedItemNames.includes('Heater/ Defroster') },
            { id: 'wipersWasher', name: 'Wipers & Washer Fluid', selected: selectedItemNames.includes('Wipers & Washer Fluid') },
            { id: 'windshieldMirror', name: 'Windshield & Mirror', selected: selectedItemNames.includes('Windshield & Mirror') },
            { id: 'fireExtinguisher', name: 'Fire Extinguisher', selected: selectedItemNames.includes('Fire Extinguisher') }
        ];
        
        setInspectionItems(updatedItems);
        setEditMode(true);
        setOpen(true);
    }

    return (
        <div>
            {tokenExpired && (<TokenError/>)}

            <Typography style={{ fontSize: '28px', fontWeight: '500' }}>
                Inspection
            </Typography>

            <Grid2 container spacing={2} alignItems="flex-end" style={{ marginBottom: '2%' }}>
                <Grid2 item sx={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                    <Typography variant="subtitle2" sx={{ fontWeight: '500', color: '#555', visibility: 'hidden' }}>Placeholder</Typography>
                    <Select value={cityFilter} 
                        onChange={(e) => handleCityChange(e.target.value)} displayEmpty
                        style={{width: '190px',height:'50px',borderRadius:'8px',backgroundColor: cityFilter ? '#F9F9F9' : '#FFFFFF'}}>
                            <MenuItem value="">Select City</MenuItem>
                            {cities.map((city) => (
                                <MenuItem key={city.city_name} value={city.city_id}>
                                    {city.city_name}
                                </MenuItem>
                            ))}
                    </Select>
                </Grid2>

                <Grid2 item sx={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                    <Typography sx={{ fontWeight: '500'}}>Inspection Category:</Typography>
                    <Select value={inspectionCategoryFilter} 
                        onChange={(e) => setInspectionCategoryFilter(e.target.value)} displayEmpty
                        style={{width: '190px',height:'50px',borderRadius:'8px',backgroundColor: cityFilter ? '#F9F9F9' : '#FFFFFF'}}>
                        <MenuItem value="">All</MenuItem>
                        <MenuItem value="Driver Area">Driver Area</MenuItem>
                        <MenuItem value="Chassis">Chassis</MenuItem>
                        <MenuItem value="Electrical System">Electrical System</MenuItem>
                        <MenuItem value="Fluids & Engine Compartment">Fluids & Engine Compartment</MenuItem>
                        <MenuItem value="Exterior and Undercarriage">Exterior and Undercarriage</MenuItem>
                    </Select>
                </Grid2>

                <Grid2 item sx={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                    <Typography variant="subtitle2" sx={{ fontWeight: '500', color: '#555', visibility: 'hidden' }}>Placeholder</Typography>
                    <Button
                        variant="contained"
                        onClick={handleOpenAddInspection}
                        style={{
                            width: '185px',
                            height: '50px',
                            backgroundColor: '#000000',
                            textTransform: 'none',
                            borderRadius: '8px',
                        }}
                    >
                        + Add Inspection
                    </Button>
                </Grid2>
            </Grid2>

            <div
                style={{
                    position: 'fixed',
                    top: 65,
                    right: open ? 0 : '-100%',
                    height: '100%',
                    width: '50%',
                    backgroundColor: '#f9f9f9',
                    boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
                    transition: 'right 0.3s ease-in-out',
                    zIndex: 1000,
                    overflowY: 'auto',
                    padding: 20
                }}
            >
                <Box onClose={handleCloseAddInspection} editMode={editMode}>
                    <div style={{ position: 'relative', padding: '40px 0' }}>
                        {/* Close Button Outside the Card */}
                        <IconButton
                            aria-label="close"
                            onClick={handleCloseAddInspection}
                            style={{
                                position: 'absolute',
                                top: '-15px', // Position it above the Paper component
                                left: '1px',
                                color: '#333',
                                zIndex: 10,
                            }}
                        >
                            <CloseIcon style={{ fontSize: '32px', fontWeight: 'bold' }} />
                        </IconButton>
                        <Paper elevation={3}
                            style={{ padding: '30px', maxWidth: '800px', margin: '0 auto',
                                backgroundColor: '#FFFFFF', borderRadius: '12px'}}>
                            <Typography style={{ marginBottom: '20px', fontWeight: '500', fontSize:'24px' }}>
                                {editMode ? 'Edit Inspection' : 'Add Inspection'}
                            </Typography>

                            <Grid container spacing={2}>

                                <Grid item xs={12} sm={12}>
                                    <Label style={{color:'#1A1E25', fontSize:'16px'}}>License Plate Number<span style={{ color: 'red' }}>*</span></Label>
                                    <Select 
                                        value={plateNumber} 
                                        onChange={(e) => {
                                            setPlateNumber(e.target.value);
                                            setFormErrors({...formErrors, plateNumber: !e.target.value});
                                        }} 
                                        displayEmpty
                                        error={formErrors.plateNumber}
                                        style={{width: '100%',height:'50px',borderRadius:'12px',backgroundColor: plateNumber ? '#F9F9F9' : '#FFFFFF',
                                            border: formErrors.plateNumber ? '1px solid #d32f2f' : 'none'}}>
                                        <MenuItem value="">Select License Plate Number</MenuItem>
                                        {chassisData.map((chassis) => (
                                            <MenuItem key={chassis.license_plate_no} value={chassis.license_plate_no}>
                                                {chassis.license_plate_no}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </Grid>

                                {/* {editMode && (
                                    <Grid item xs={12} sm={12}>
                                        <Label style={{color:'#1A1E25', fontSize:'16px'}}>License Plate Number<span style={{ color: 'red' }}>*</span></Label>
                                        <Select value={status} 
                                            onChange={(e) => setStatus(e.target.value)} displayEmpty
                                            style={{width: '100%',height:'50px',borderRadius:'12px',backgroundColor: plateNumber ? '#F9F9F9' : '#FFFFFF'}}>
                                            <MenuItem value="1">Active</MenuItem>
                                            <MenuItem value="0">Inactive</MenuItem>
                                        </Select>
                                    </Grid>
                                )} */}

                                {/* <Grid item xs={12} sm={6}>
                                        <Label>Start Date<span style={{ color: 'red' }}>*</span></Label>
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DemoContainer components={['DatePicker']}>
                                                <DatePicker sx={{height:'50px'}}
                                                value={startDate}
                                                onChange={(newValue) => setStartDate(newValue)}
                                                />
                                            </DemoContainer>
                                        </LocalizationProvider>
                                        
                                    </Grid>

                                    <Grid item xs={12} sm={6}>
                                        <Label>End Date<span style={{ color: 'red' }}>*</span></Label>
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DemoContainer components={['DatePicker']}>
                                                <DatePicker sx={{height:'50px'}}
                                                value={endDate}
                                                onChange={(newValue) => {
                                                    if (newValue && dayjs(newValue).isBefore(startDate)) {
                                                        alert("End Date cannot be earlier than Start Date"); // Display an alert or handle error
                                                    } else {
                                                        setEndDate(newValue); // Update state if valid
                                                    }
                                                }}
                                                />
                                            </DemoContainer>
                                        </LocalizationProvider>
                                    </Grid> */}
                                    <Grid item xs={12} sm={6}>
                                        <Label>Start Date & Time<span style={{ color: 'red' }}>*</span></Label>
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DemoContainer
                                                components={['DateTimePicker']}
                                                sx={{
                                                    marginTop: '8px',
                                                    '& .MuiStack-root': {
                                                        padding: 0
                                                    }
                                                }}
                                            >
                                                <DateTimePicker
                                                    sx={{
                                                        width: '100%',
                                                        '& .MuiOutlinedInput-root': {
                                                            height: '52px',
                                                            borderRadius: '12px',
                                                            backgroundColor: '#FFFFFF',
                                                            border: formErrors.startDate ? '1px solid #d32f2f' : undefined
                                                        },
                                                        '& .MuiInputBase-input': {
                                                            fontSize: '16px',
                                                            padding: '8px 14px'
                                                        }
                                                    }}
                                                    value={startDate}
                                                    onChange={(newValue) => {
                                                        setStartDate(newValue);
                                                        setFormErrors({...formErrors, startDate: !newValue});
                                                    }}
                                                    format="YYYY-MM-DD HH:mm"
                                                    ampm={false}
                                                    slotProps={{
                                                        textField: {
                                                            fullWidth: true,
                                                            placeholder: 'Select date and time',
                                                            error: formErrors.startDate
                                                        }
                                                    }}
                                                />
                                            </DemoContainer>
                                        </LocalizationProvider>
                                        
                                    </Grid>

                                    <Grid item xs={12} sm={6}>
                                        <Label>Drop Date<span style={{ color: 'red' }}>*</span></Label>
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DemoContainer
                                                components={['DateTimePicker']}
                                                sx={{
                                                    marginTop: '8px',
                                                    '& .MuiStack-root': {
                                                        padding: 0
                                                    }
                                                }}
                                            >
                                                <DateTimePicker
                                                    sx={{
                                                        width: '100%',
                                                        '& .MuiOutlinedInput-root': {
                                                            height: '52px',
                                                            borderRadius: '12px',
                                                            backgroundColor: '#FFFFFF',
                                                            border: formErrors.endDate ? '1px solid #d32f2f' : undefined
                                                        },
                                                        '& .MuiInputBase-input': {
                                                            fontSize: '16px',
                                                            padding: '8px 14px'
                                                        }
                                                    }}
                                                    value={endDate}
                                                    onChange={(newValue) => {
                                                        if (newValue && dayjs(newValue).isBefore(startDate)) {
                                                            setMessage("Drop date & time cannot be earlier than start date & time");
                                                            showSnackbar(true);
                                                        } else {
                                                            setEndDate(newValue);
                                                            setFormErrors({...formErrors, endDate: !newValue});
                                                        }
                                                    }}
                                                    format="YYYY-MM-DD HH:mm"
                                                    ampm={false}
                                                    slotProps={{
                                                        textField: {
                                                            fullWidth: true,
                                                            placeholder: 'Select date and time',
                                                            error: formErrors.endDate
                                                        }
                                                    }}
                                                    minDateTime={startDate}
                                                />
                                            </DemoContainer>
                                        </LocalizationProvider>
                                    </Grid>

                                    <Grid item xs={12} sm={12}>
                                        <Grid2 sx={{ border: formErrors.inspectionCategory ? '1px solid #d32f2f' : '1px solid #D1D5DB', padding:'12px', borderRadius:'12px' }}>
                                            <Label style={{color: formErrors.inspectionCategory ? '#d32f2f' : '#1A1E25', fontSize:'16px'}}>Inspection Category<span style={{ color: 'red' }}>*</span></Label>
                                            {formErrors.inspectionCategory && <Typography sx={{ color: '#d32f2f', fontSize: '0.75rem', mt: 0.5 }}>Please select an inspection category</Typography>}
                                            <Grid container spacing={2} sx={{ mt: 1 }}>
                                                <Grid item xs={6}>
                                                    <Box sx={{ 
                                                        display: 'flex', 
                                                        alignItems: 'center',
                                                        borderRadius: '8px',
                                                        mb: 1
                                                    }}>
                                                        <input
                                                            type="radio"
                                                            id="driverArea"
                                                            name="inspectionCategory"
                                                            value="Driver Area"
                                                            style={{ marginRight: '10px' }}
                                                            checked={inspectionCategory === 'Driver Area'}
                                                            onChange={(e) => {
                                                                setInspectionCategory(e.target.value);
                                                                setFormErrors({...formErrors, inspectionCategory: false});
                                                            }}
                                                        />
                                                        <label htmlFor="driverArea">Driver Area</label>
                                                    </Box>
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <Box sx={{ 
                                                        display: 'flex', 
                                                        alignItems: 'center', 
                                                        borderRadius: '8px',
                                                        mb: 1
                                                    }}>
                                                        <input
                                                            type="radio"
                                                            id="chassis"
                                                            name="inspectionCategory"
                                                            value="Chassis"
                                                            style={{ marginRight: '10px' }}
                                                            checked={inspectionCategory === 'Chassis'}
                                                            onChange={(e) => setInspectionCategory(e.target.value)}
                                                        />
                                                        <label htmlFor="chassis">Chassis</label>
                                                    </Box>
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <Box sx={{ 
                                                        display: 'flex', 
                                                        alignItems: 'center', 
                                                        borderRadius: '8px',
                                                        mb: 1
                                                    }}>
                                                        <input
                                                            type="radio"
                                                            id="electricalSystem"
                                                            name="inspectionCategory"
                                                            value="Electrical System"
                                                            style={{ marginRight: '10px' }}
                                                            checked={inspectionCategory === 'Electrical System'}
                                                            onChange={(e) => setInspectionCategory(e.target.value)}
                                                        />
                                                        <label htmlFor="electricalSystem">Electrical System</label>
                                                    </Box>
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <Box sx={{ 
                                                        display: 'flex', 
                                                        alignItems: 'center',
                                                        borderRadius: '8px',
                                                        mb: 1
                                                    }}>
                                                        <input
                                                            type="radio"
                                                            id="fluidsEngine"
                                                            name="inspectionCategory"
                                                            value="Fluids & Engine Compartment"
                                                            style={{ marginRight: '10px' }}
                                                            checked={inspectionCategory === 'Fluids & Engine Compartment'}
                                                            onChange={(e) => setInspectionCategory(e.target.value)}
                                                        />
                                                        <label htmlFor="fluidsEngine">Fluids & Engine Compartment</label>
                                                    </Box>
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <Box sx={{ 
                                                        display: 'flex', 
                                                        alignItems: 'center',
                                                        borderRadius: '8px',
                                                        mb: 1
                                                    }}>
                                                        <input
                                                            type="radio"
                                                            id="exteriorUndercarriage"
                                                            name="inspectionCategory"
                                                            value="Exterior and Undercarriage"
                                                            style={{ marginRight: '10px' }}
                                                            checked={inspectionCategory === 'Exterior and Undercarriage'}
                                                            onChange={(e) => setInspectionCategory(e.target.value)}
                                                        />
                                                        <label htmlFor="exteriorUndercarriage">Exterior and Undercarriage</label>
                                                    </Box>
                                                </Grid>
                                            </Grid>
                                        </Grid2>
                                    </Grid>

                                    <Grid item xs={12} sm={12}>
                                        <Label style={{color:'#1A1E25', fontSize:'16px'}}>Inspection Item<span style={{ color: 'red' }}>*</span></Label>
                                        <Box sx={{ 
                                            position: 'relative',
                                            width: '100%',
                                            mt: 1,
                                            mb: 2
                                        }}>
                                            <TextField
                                                placeholder="Search items"
                                                fullWidth
                                                variant="outlined"
                                                value={searchItemText}
                                                onChange={(e) => setSearchItemText(e.target.value)}
                                                InputProps={{
                                                    startAdornment: (
                                                        <Box sx={{ mr: 1 }}>
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                                <circle cx="11" cy="11" r="8"></circle>
                                                                <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                                                            </svg>
                                                        </Box>
                                                    ),
                                                    style: {
                                                        height: '52px',
                                                        borderRadius: '12px',
                                                        fontSize: '16px',
                                                        backgroundColor: '#FFFFFF'
                                                    }
                                                }}
                                            />
                                            <Box sx={{
                                                mt: 1,
                                                border: formErrors.inspectionItem ? '1px solid #d32f2f' : '1px solid #E5E7EB',
                                                borderRadius: '8px',
                                                maxHeight: '300px',
                                                overflowY: 'auto'
                                            }}>
                                                {filteredItems.map((item) => (
                                                    <Box sx={{ p: 2, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }} key={item.id}>
                                                        <Typography>{item.name}</Typography>
                                                        <input 
                                                            type="checkbox" 
                                                            checked={item.selected} 
                                                            onChange={() => {
                                                                handleItemChange(item.id);
                                                                // Will clear error once at least one item is selected
                                                                const updatedItems = inspectionItems.map(i => 
                                                                    i.id === item.id ? { ...i, selected: !i.selected } : i
                                                                );
                                                                const anySelected = updatedItems.some(i => i.selected);
                                                                setFormErrors({...formErrors, inspectionItem: !anySelected});
                                                            }} />
                                                    </Box>
                                                ))}
                                            </Box>
                                        </Box>
                                    </Grid>

                                    <Grid item xs={12} sm={12}>
                                        <Label style={{color:'#1A1E25', fontSize:'16px'}}>Inspected By<span style={{ color: 'red' }}>*</span></Label>
                                        <TextField 
                                            sx={{marginTop:'1%'}} 
                                            placeholder="Jamie" 
                                            fullWidth 
                                            variant="outlined"
                                            value={inspectedBy}
                                            onChange={(e) => {
                                                setInspectedBy(e.target.value);
                                                setFormErrors({...formErrors, inspectedBy: !e.target.value.trim()});
                                            }}
                                            error={formErrors.inspectedBy}
                                            helperText={formErrors.inspectedBy ? 'Inspected By is required' : ''}
                                            InputProps={{
                                                startAdornment: (
                                                    <Box sx={{ mr: 1 }}>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                                                            <circle cx="12" cy="7" r="4"></circle>
                                                        </svg>
                                                    </Box>
                                                ),
                                                style: {
                                                    height: '52px',
                                                    borderRadius:'12px',
                                                    fontSize: '16px',
                                                    backgroundColor: '#FFFFFF'
                                                }
                                            }}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={12}>
                                        <Grid2 sx={{ border: '1px solid #D1D5DB', padding:'12px', borderRadius:'12px' }}>
                                            <Label style={{color:'#1A1E25', fontSize:'16px'}}>Inspection Status<span style={{ color: 'red' }}>*</span></Label>
                                            <Grid container spacing={2} sx={{ mt: 1 }}>
                                                <Grid item xs={6}>
                                                    <Box sx={{ 
                                                        display: 'flex', 
                                                        alignItems: 'center',
                                                        borderRadius: '8px'
                                                    }}>
                                                        <input
                                                            type="radio"
                                                            id="go"
                                                            name="inspectionStatus"
                                                            value="1"
                                                            style={{ marginRight: '10px' }}
                                                            checked={inspectionStatus == 1}
                                                            onChange={(e) => setInspectionStatus(e.target.value)}
                                                        />
                                                        <label htmlFor="go">GO</label>
                                                    </Box>
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <Box sx={{ 
                                                        display: 'flex', 
                                                        alignItems: 'center',
                                                        borderRadius: '8px'
                                                    }}>
                                                        <input
                                                            type="radio"
                                                            id="noGo"
                                                            name="inspectionStatus"
                                                            value="0"
                                                            style={{ marginRight: '10px' }}
                                                            checked={inspectionStatus == 0}
                                                            onChange={(e) => setInspectionStatus(e.target.value)}
                                                        />
                                                        <label htmlFor="noGo">NO-GO</label>
                                                    </Box>
                                                </Grid>
                                            </Grid>
                                        </Grid2>
                                    </Grid>

                            </Grid>

                            <div style={{ marginTop: '40px', display: 'flex', justifyContent: 'center', gap: '20px', marginBottom: '6%' }}>
                                <Button variant="contained"
                                    onClick={handleSubmit}
                                    sx={{
                                        width: '140px',height: '50px', textTransform: 'none',fontSize: '16px',
                                        backgroundColor: '#0065FF',color: 'white',
                                    }}
                                >
                                    {editMode ? 'Update' : 'Save'}
                                </Button>
                                <Button
                                    variant="contained"
                                    onClick={handleCloseAddInspection}
                                    sx={{
                                        width: '140px',height: '50px',textTransform: 'none',
                                        fontSize: '16px',backgroundColor: '#F0F0F0',color: '#B0B0B0'
                                    }}
                                >
                                    Cancel
                                </Button>
                            </div>
                        </Paper>

                    </div>
                </Box>
            </div>

            <TableContainer className="table-container">
                <Table stickyHeader className="scrollable-table">
                    <TableHead>
                        <TableRow>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>
                                <TableSortLabel
                                    active={orderBy === 'inspection_id'}
                                    direction={orderBy === 'inspection_id' ? order : 'asc'}
                                    onClick={() => handleRequestSort('inspection_id')}
                                >
                                    Inspection ID
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>
                                <TableSortLabel
                                    active={orderBy === 'license_plate_no'}
                                    direction={orderBy === 'license_plate_no' ? order : 'asc'}
                                    onClick={() => handleRequestSort('license_plate_no')}
                                >
                                    License Plate No
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>
                                <TableSortLabel
                                    active={orderBy === 'start_date'}
                                    direction={orderBy === 'start_date' ? order : 'asc'}
                                    onClick={() => handleRequestSort('start_date')}
                                >
                                    Start Date
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>
                                <TableSortLabel
                                    active={orderBy === 'end_date'}
                                    direction={orderBy === 'end_date' ? order : 'asc'}
                                    onClick={() => handleRequestSort('end_date')}
                                >
                                    End Date
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>
                                <TableSortLabel
                                    active={orderBy === 'category'}
                                    direction={orderBy === 'category' ? order : 'asc'}
                                    onClick={() => handleRequestSort('category')}
                                >
                                    Category
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>
                                <TableSortLabel
                                    active={orderBy === 'item'}
                                    direction={orderBy === 'item' ? order : 'asc'}
                                    onClick={() => handleRequestSort('item')}
                                >
                                    Item
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>
                                <TableSortLabel
                                    active={orderBy === 'inspection_by'}
                                    direction={orderBy === 'inspection_by' ? order : 'asc'}
                                    onClick={() => handleRequestSort('inspection_by')}
                                >
                                    Inspected By
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>
                                <TableSortLabel
                                    active={orderBy === 'inspection_status'}
                                    direction={orderBy === 'inspection_status' ? order : 'asc'}
                                    onClick={() => handleRequestSort('inspection_status')}
                                >
                                    Inspection Status
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>Action</TableCell>
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {rows.length === 0 && (
                            <TableRow>
                                <TableCell colSpan={13} align="center">
                                    <Typography variant="body1">No data found</Typography>
                                </TableCell>
                            </TableRow>
                        )}
                        {(rowsPerPage > 0
                            ? rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                            : rows
                        ).map((row) => {

                            return(
                                <TableRow key={row.inspection_id}>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.inspection_id}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.license_plate_no}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>
                                        {row.start_date ? dayjs(row.start_date).format('YYYY-MM-DD HH:mm:ss') : ''}
                                    </Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>
                                        {row.end_date ? dayjs(row.end_date).format('YYYY-MM-DD HH:mm:ss') : ''}
                                    </Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.category}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.item}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.inspection_by}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.inspection_status==1 ? 'GO' : 'NO-GO'}</Typography></TableCell>
                                    {/* <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.status==1 ? 'Active' : 'Inactive'}</Typography></TableCell> */}
                                    <TableCell align="center">
                                        <Button
                                            variant="contained"
                                            onClick={() => handleOpenEditChassis(row)}
                                            sx={{
                                                backgroundColor: '#EFFBF7', color: '#0DBA78', border: '1px solid #0DBA78', textTransform: 'none',
                                                borderRadius: '8px', minWidth:'40px', boxShadow:'none', width:"90px",
                                                '&:hover': {backgroundColor: '#0DBA78', color: 'white'},
                                                '&:active': { backgroundColor: '#0DBA78', color: 'white'}
                                            }}
                                        >
                                            
                                            <Typography sx={{marginRight:'6%'}}>Edit</Typography>
                                        </Button>
                                    </TableCell>
                                </TableRow>
                            )
                        })}
                    </TableBody>
                </Table>
                <div className="custom-pagination">
                    <div className="pagination-info">
                        {`Showing ${page * rowsPerPage + 1} to ${Math.min(
                            (page + 1) * rowsPerPage,
                            rows.length
                        )} of ${rows.length} entries`}
                    </div>
                    <div className="pagination-controls">
                    <button
                        onClick={() => handleChangePage(null, page - 1)}
                        disabled={page === 0}
                        className="pagination-arrow"
                    >
                        <img src={prevIcon} alt="Previous" />
                    </button>
                        <div className="pagination-numbers">
                            {[...Array(Math.ceil(rows.length / rowsPerPage))].map((_, index) => (
                                <button key={index} onClick={() => handleChangePage(null, index)}
                                    className={`pagination-number ${ page === index ? 'active' : ''}`}>
                                    {index + 1}
                                </button>
                            ))}
                        </div>
                        <button
                            onClick={() => handleChangePage(null, page + 1)}
                            disabled={page >= Math.ceil(rows.length / rowsPerPage) - 1}
                            className="pagination-arrow"
                        >
                            <img src={nextIcon} alt="Next" />
                        </button>
                    </div>
                </div>
            </TableContainer>

            <Snackbar open={snackbar} autoHideDuration={2000} onClose={handleSnackbarClose} message={message}></Snackbar>
            
        </div>
    )
}

export default Inspection;